<template>
  <div
    v-if="isOlderVersion || isPrereleaseVersion"
    class="card text-left inverted"
  >
    <div class="display-flex flex-column laptop:flex-row laptop:flex-items-center laptop:flex-content-between size-sm">
      <div class="margin-bottom-xl laptop:margin-bottom-0 laptop:margin-right-xl">
        <slot name="message">
          <p style="--paragraph-margin-bottom: 0">
            <font-awesome-icon
              :icon="$v7.duotone.faCircleInfo"
              size="xl"
              class="margin-right-sm"
              style="--fa-secondary-opacity: 1; --fa-secondary-color: var(--fa-dk-blue); --fa-primary-color: var(--white)"
            />

            You're viewing
            <template v-if="subject">{{ titleCase(subject) }} for</template>
            <strong>v{{ $releases.active.version }}</strong
            >, <template v-if="isOlderVersion">an <strong>older version</strong></template
            ><template v-else>a <strong>prerelease version</strong></template> of Font Awesome.
          </p>
        </slot>
      </div>
      <div>
        <slot name="action">
          <site-link
            :to="link"
            class="accent no-underline"
            style="font-weight: var(--font-weight-bold)"
          >
            View the latest!
            <font-awesome-icon
              :icon="$v7.solid.faArrowRight"
              class="margin-left-xs"
            />
          </site-link>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
  import startCase from 'lodash/startCase'

  export default {
    name: 'VersionAlert',

    props: {
      subject: {
        type: String
      },
      isIndividualIcon: {
        type: Boolean
      },
      isIndividualIconPack: {
        type: Boolean
      }
    },

    computed: {
      isOlderVersion() {
        const activeVersion = this.$releases.active
        const latestVersion = this.$releases.latest.together

        return activeVersion.versionParts.major < latestVersion.versionParts.major
      },

      isPrereleaseVersion() {
        return !!this.$releases.active.versionParts.pre
      },

      link() {
        if (!this.subject) return { name: 'home' }

        const routes = {
          changelog: { name: 'changelog' },
          icons: { name: 'latest.icons' },
          search: { name: 'latest.search' }
        }

        if (routes[this.subject]) return routes[this.subject]

        if (this.isIndividualIcon) {
          return {
            name: 'latest.icons.detail',
            params: { icon: this.subject }
          }
        }

        if (this.isIndividualIconPack) {
          return {
            name: 'latest.icons.packs.detail',
            params: { pack: this.subject }
          }
        }

        return { name: 'home' }
      }
    },

    methods: {
      titleCase(value) {
        return startCase(value)
      }
    }
  }
</script>
